import { ScopeBlock } from './blocks/logic/scope-block.js'
import { FormBlock } from './blocks/form/form-block.js'
import { Process } from './bos/process.js'
import { Trigger } from './bos/trigger.js'
import { Theme } from './bos/theme.js'
import { AccessControl } from './bos/access-control.js'
import { Resource } from './bos/resource.js'
import { Language } from './bos/language.js'
import { CheckboxBlock } from './blocks/form/checkbox-block.js'
import { DropdownBlock } from './blocks/form/dropdown-block.js'
import { LinkBlock } from './blocks/other/link-block.js'
import { ListBlock } from './blocks/layout/list-block.js'
import { ToolbarBlock } from './blocks/layout/toolbar-block.js'
import { MainLayoutBlock } from './blocks/layout/main-layout-block.js'
import { ServerDataStore } from './bos/server-data-store.js'
import { ServiceIntegration } from './bos/service-integration.js'
import { DataType } from './bos/data-type.js'
import { Role } from './bos/role.js'
import { Permission } from './bos/permission.js'
import { StaticEntity } from './bos/static-entity.js'
import { Label } from './bos/label.js'
import { ConfigurationItem } from './bos/configuration-item.js'
import { User } from './auth/index.js'
import { RawHtmlBlock } from './blocks/layout/raw-html-block.js'
import { Screen } from './bos/screen.js'
import { ScreenBlock } from './blocks/layout/screen-block.js'
import { ForBlock } from './blocks/logic/for-block.js'
import { IfBlock } from './blocks/logic/if-block.js'
import { LayoutBlock } from './blocks/layout/layout-block.js'
import { InputBlock } from './blocks/form/input-block.js'
import { TextBlock } from './blocks/other/text-block.js'
import { Module } from './bos/module.js'
import { Entity } from './bos/entity.js'
import { UserDefinedConfiguration } from './bos/user-defined-configuration.js'
import { ButtonBlock } from './blocks/form/button-block.js'
import { MainLayoutSidebarBlock } from './blocks/layout/main-layout-sidebar-block.js'
import { ContentAreaBlock } from './blocks/layout/content-area-block.js'
import { ListItemBlock } from './blocks/layout/list-item-block.js'
import { DatePickerBlock } from './blocks/form/datepicker-block.js'
import { PlaceholderBlock } from './blocks/layout/placeholder-block.js'
import { PdfBlock } from './blocks/other/pdf-block.js'
import { ImageBlock } from './blocks/other/image-block.js'
import { VideoBlock } from './blocks/other/video-block.js'
import { NamedGridBlock } from './blocks/layout/named-grid-block.js'
import { DataTableBlock } from './blocks/layout/data-table-block.js'
import { DataTableColumnBlock } from './blocks/layout/data-table-column-block.js'
import { TabGroupBlock } from './blocks/layout/tab-group-block.js'
import { TabGroupTabBlock } from './blocks/layout/tab-group-tab-block.js'
import {
	FileUploadBlock,
	RichTextEditorBlock,
	SliderBlock,
} from './blocks/index.js'
import { ElseBlock } from './blocks/logic/else-block.js'
import { DisableBlock } from './blocks/logic/disable-block.js'
import { LogEntry } from './monitoring/log-entry.js'
import { Tenant } from './tenants/tenant.js'
import { SearchableDropdownBlock } from './blocks/form/searchable-dropdown-block.js'
import { IconBlock } from './blocks/other/icon-block.js'
import { DividerBlock } from './blocks/layout/divider-block.js'
import { ExpansionPanelBlock } from './blocks/layout/expansion-panel-block.js'
import { ToggleGroupBlock } from './blocks/form/toggle-group-block.js'
import { CardBlock } from './blocks/layout/card-block.js'
import { LanguageSwitcherBlock } from './blocks/other/language-switcher-block.js'
import { LoginBlock } from './blocks/other/login-block.js'
import { ChartBlock } from './blocks/other/chart-block.js'
import { SpinnerBlock } from './blocks/other/spinner-block.js'
import { StepperBlock } from './blocks/form/stepper-block.js'
import { StepperStepBlock } from './blocks/form/stepper-step-block.js'
import { Lock } from './lock/lock.js'
import { DeploymentContainer } from './deployment/deployment-container.js'
import { DeploymentSource } from './deployment/deployment-source.js'
import { DeploymentAuthorization } from './deployment/deployment-authorization.js'
import { TriggerConfiguration } from './trigger/trigger-configuration.js'
import { IdentityProvider } from './auth/identity-provider.js'
import { ServiceProvider } from './bos/service-provider.js'
import { MappableSharedRootClasses } from './shared-classes.js'
import { MainLayoutSidebarToggleButtonBlock } from './blocks/layout/main-layout-sidebar-toggle-button-block.js'
import { ValidatorBlock } from './blocks/form/validator-block.js'
import { NavigationListBlock } from './blocks/layout/navigation-list-block.js'
import { NavigationItemBlock } from './blocks/layout/navigation-item-block.js'
import { ClientDataStore } from './bos/client-data-store.js'
import { Branch } from './bos/branch.js'
import { DraggableBlock } from './blocks/other/draggable-block.js'
import { DropListBlock } from './blocks/other/drop-list-block.js'
import { DropListGroupBlock } from './blocks/other/drop-list-group-block.js'
import { DraggableHandleBlock } from './blocks/other/draggable-handle-block.js'
import { AuditTrailEntry } from './audit/audit-trail-entry.js'
import { ChatAuditTrailBlock } from './blocks/other/chat-audit-trail-block.js'
import { ContextMenuBlock } from './blocks/layout/context-menu-block.js'
import { IgnoreValidationsBlock } from './blocks/logic/ignore-validations-block.js'
import { PhoneInputBlock } from './blocks/form/phone-input-block.js'
import { Report } from './bos/report.js'
import { ReportBlock } from './blocks/other/report-block.js'
import { ImageSelectorBlock } from './blocks/other/image-selector-block.js'
import { ChipGroupBlock } from './blocks/form/chip-group-block.js'

export const AllConcreteBlockTypes = [
	// core blocks
	TextBlock,
	LinkBlock,
	InputBlock,
	DropdownBlock,
	CheckboxBlock,
	DatePickerBlock,
	ButtonBlock,
	IconBlock,
	ImageBlock,
	// logic blocks
	IfBlock,
	ElseBlock,
	ForBlock,
	DisableBlock,
	IgnoreValidationsBlock,
	ScopeBlock,
	// layout blocks
	LayoutBlock,
	NamedGridBlock,
	CardBlock,
	ContextMenuBlock,
	// tables & lists
	DataTableBlock,
	DataTableColumnBlock,
	ListBlock,
	ListItemBlock,
	// additional form fields
	ChipGroupBlock,
	FormBlock,
	ToggleGroupBlock,
	FileUploadBlock,
	SearchableDropdownBlock,
	SliderBlock,
	StepperBlock,
	StepperStepBlock,
	RichTextEditorBlock,
	ValidatorBlock,
	PhoneInputBlock,
	// screen structure blocks
	ScreenBlock,
	PlaceholderBlock,
	ContentAreaBlock,
	TabGroupBlock,
	TabGroupTabBlock,
	ToolbarBlock,
	ExpansionPanelBlock,
	DividerBlock,
	NavigationListBlock,
	NavigationItemBlock,
	MainLayoutBlock,
	MainLayoutSidebarBlock,
	MainLayoutSidebarToggleButtonBlock,
	// other blocks
	ChartBlock,
	ChatAuditTrailBlock,
	DraggableBlock,
	DraggableHandleBlock,
	DropListBlock,
	DropListGroupBlock,
	ImageSelectorBlock,
	LanguageSwitcherBlock,
	PdfBlock,
	ReportBlock,
	SpinnerBlock,
	RawHtmlBlock,
	VideoBlock,
	LoginBlock,
] as const

export const AllConcreteBlockTypesMap = Object.fromEntries(
	AllConcreteBlockTypes.map((blockType) => [new blockType().__type, blockType]),
)

export const BusinessObjectClassesMap = {
	Module,
	AccessControl,
	ConfigurationItem,
	ClientDataStore,
	Entity,
	StaticEntity,
	Label,
	Screen,
	Process,
	Role,
	Permission,
	DataType,
	Report,
	ServerDataStore,
	ServiceIntegration,
	ServiceProvider,
	Resource,
	Language,
	Trigger,
	Theme,
	UserDefinedConfiguration,
} as const

export const MappableLgRootClasses = {
	...MappableSharedRootClasses,
	...BusinessObjectClassesMap,
	Module,
	// Dtos
	Branch,
	Tenant,
	User,
	IdentityProvider,
	LogEntry,
	Lock,
	DeploymentContainer,
	DeploymentSource,
	DeploymentAuthorization,
	TriggerConfiguration,
	AuditTrailEntry,
} as const

export const MappableLgClasses = {
	...MappableLgRootClasses,
	...AllConcreteBlockTypesMap,
}
